<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
      <el-row>
        <el-col :span="10">
          <el-form-item label="明细登记项名称" prop="detailItemName">
            <el-select
              size="small"
              v-model="formData.detailItemName"
              :disabled="disabled"
              placeholder="请选择明细登记项名称"
              style="width: 100%"
              filterable
              clearable
            >
              <el-option
                v-for="item in materialItemNameList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :offset="14"></el-col>
        <el-col :span="20">
          <el-form-item label="明细登记项值" prop="detailItemValue">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 6 }"
              v-model="formData.detailItemValue"
              maxlength="500"
              :disabled="disabled"
              clearable
              size="mini"
              placeholder="请输入明细登记项值"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :offset="4"></el-col>
        <el-col :span="20">
          <el-form-item label="注意事项" prop="detailItemNotice">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 6 }"
              v-model="formData.detailItemNotice"
              maxlength="500"
              :disabled="disabled"
              clearable
              size="mini"
              placeholder="请输入注意事项"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="20">
          <el-form-item label="备注信息" prop="detailItemRemark">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 6 }"
              v-model="formData.detailItemRemark"
              maxlength="500"
              :disabled="disabled"
              clearable
              size="mini"
              placeholder="请输入备注信息"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
// import { getMaterialItemNameList, updateProjectInfoMaterial, addSingleMaterialItem } from '@api/projectManager/infoMaterial'
export default {
  props: {
    params: {
      default: null,
      type: Object
    }
  },
  data() {
    return {
      disabled: false,
      formData: {
        prjCode: '',
        detailItemName: '',
        detailItemValue: '',
        detailItemNotice: '',
        detailItemRemark: '',
        prjInfoMaterialCode: '',
        seqno: ''
      },
      editType: '',
      materialItemNameList: [],
      rules: {
        detailItemName: [
          {
            required: true,
            message: '请输入明细登记项名称',
            trigger: 'change'
          },
          { max: 50, message: '长度在50个字符以内', trigger: 'blur' }
        ],
        detailItemValue: [
          { required: true, message: '请输入明细登记项值', trigger: 'blur' },
          { max: 500, message: '长度在500个字符以内', trigger: 'blur' }
        ],
        detailItemNotice: [
          { required: false, message: '请输入注意事项', trigger: 'blur' },
          { max: 500, message: '长度在500个字符以内', trigger: 'blur' }
        ],
        detailItemRemark: [
          { required: false, message: '请输入备注信息', trigger: 'blur' },
          { max: 500, message: '长度在500个字符以内', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 加载表单数据（新增，编辑，详情）
    fromLoad(ref, val = '') {
      this.init()
      this.loadSelect()
      this.editType = ref
      if (ref !== 'add') {
        this.formData.detailItemName = val.detailItemName
        this.formData.detailItemNotice = val.detailItemNotice
        this.formData.detailItemRemark = val.detailItemRemark
        this.formData.detailItemValue = val.detailItemValue
        this.formData.prjCode = val.prjCode
        this.formData.prjInfoMaterialCode = val.prjInfoMaterialCode
        this.formData.seqno = val.seqno
        // 控制组件不可编辑
        if (ref === 'detail') {
          this.disabled = true
        }
      } else {
        this.formData.prjCode = val
        this.formData.prjInfoMaterialCode = ''
        this.formData.seqno = ''
      }
    },
    // 初始化表单数据
    init() {
      this.disabled = false
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    // 获取明细登记项名称下拉
    loadSelect() {
      this.$api
        .getMaterialItemNameListApi({})
        .then((res) => {
          this.materialItemNameList = res.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 保存数据
    save() {
      if (this.editType === 'add') {
        this.add()
      } else {
        this.update()
      }
    },
    update() {
      // 校验表单正确性
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.updateProjectInfoMaterialApi(this.formData).then((res) => {
            this.$message({
              showClose: true,
              message: '保存成功',
              type: 'success'
            })
            // 通知父组件保存成功
            this.$emit('success')
          })
        } else {
          return false
        }
      })
    },
    add() {
      // 校验表单正确性
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.params) {
            this.formData.prjCode = this.params.prjCode
          }
          this.$api.addSingleMaterialItemApi(this.formData).then((res) => {
            this.$message({
              showClose: true,
              message: '保存成功',
              type: 'success'
            })
            // 通知父组件保存成功
            this.$emit('success')
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
